module.exports = __webpack_public_path__ + "img/package_one.3b7153d4.jpg";